import { Meta } from '@master/model/common/Meta'

export class ContractDetailsMeta extends Meta {
  farLicense = ''
  ifpasNo = ''
}
